import {
  Component,
  OnInit,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../common/services/api.service';
import { Subject, Subscription } from 'rxjs';
import { CommonService } from '../common/services/common.service';
import { takeUntil } from 'rxjs/operators';
import { PusherEventService } from '../common/services/pusher-event.service';
import { Event as EventList } from 'src/app/pusher-event';
import { EventTrackerService } from '../common/services/event-tracker.service';
import { TranslateService } from '@ngx-translate/core';
import { TIMER, ASPECT_RATIO_MATERIAL, CASH_TABLE_SERVICE  } from 'src/defaultImages.js';

@Component({
  selector: 'app-table-service',
  templateUrl: './table-service.component.html',
  styleUrls: ['./table-service.component.css'],
})
export class TableServiceComponent implements OnInit, OnDestroy {
  images = { 
    TIMER: TIMER,
    ASPECT_RATIO_MATERIAL: ASPECT_RATIO_MATERIAL,
    CASH_TABLE_SERVICE: CASH_TABLE_SERVICE
  }
  token: string;

  activeNav = 'rn';
  currentOrderId: string;
  currentOrderNo: string;
  private subscription: Subscription[] = [];
  restaurantId: string;
  translationText;
  allOrders: {
    order_id: string;
    order_no: string;
    user_name: string;
    order_status: string;
    time_since_order: string;
    no_of_items: string;
    payment_status: string;
    floor_name: string;
    table_no: string;
    order_since: number;
    served: string;
    selected: boolean;
  }[] = [];

  allNotification: {
    table_no: string;
    floor_name: string;
    username: string;
    message: string;
    message_id: string;
    order_id: string;
    order_ids: any;
    collect_cash: boolean;
    time_stamp: number;
    time_text: string;
    specifics: any;
  }[] = [];
  modalPosition: { left: string; top: string };
  modalWidth: string;
  noNotification: boolean = false;
  private ngUnsubscribe = new Subject();

  // VALUE: any = 0;
  constructor(
    private apiService: ApiService,
    // public mqttService: MqttService,
    public dialog: MatDialog,
    private commonService: CommonService,
    private _pusherEvent: PusherEventService,
    private _eventTracker: EventTrackerService,
    public translateService: TranslateService
  ) {
    this.onResize();
    this.translateService.get(['TABLES']).subscribe((translation) => {
      this.translationText = translation.TABLES;
    });
  }
  // @ViewChild("swipeButton", { static: false }) swipeButton: ElementRef;

  // @ViewChildren("swipeButtons") swipeButtons: QueryList<ElementRef>;
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    let innerWidth = window.innerWidth;
    if (innerWidth < 768) {
      // this.modalPosition = {left : '0%',top : '0%'};
      this.modalWidth = '100vw !important';
    } else {
      // this.modalPosition = {left : '35%',top : '5%'};
      this.modalWidth = '80vw !important';
    }
  }
  ngOnInit() {
    this.activeNav = 'rn';
    this.token = localStorage.getItem('token');
    this.restaurantId = localStorage.getItem('restaurant_id');
    // this.get_my_orders();
    this.get_notification();
    // this.get_user_details();
    // this.get_tables();
    this.watchPusherEvents();
  }

  ngOnDestroy(): void {
    // this.unsubscribe_from_all_topic();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  watchPusherEvents() {
    /*Watching order  events on pusher*/

    this._pusherEvent
      .watchEvent(EventList.TABLE_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.new_message_mqtt(JSON.stringify(event)));
  }

  // subscribe_to_mqtt_topic(topic) {
  //   try {
  //     this.subscription.push(
  //       this.mqttService
  //         .observe(topic)
  //         .subscribe((message: IMqttMessage) =>
  //           this.new_message_mqtt(message.payload.toString())
  //         )
  //     );
  //   } catch (error) {
  //   }
  // }

  unsubscribe_from_all_topic() {
    try {
      this.subscription.forEach((element) => {
        element.unsubscribe();
      });
    } catch (error) {
      console.log(error);
    }
  }

  new_message_mqtt(message) {
    message = JSON.parse(message);
    // if (message['mtype'] === 'OCF') {
    //   this.subscribe_to_mqtt_topic(localStorage.getItem('restaurant_id') + '_' + message['data']['order_id']);
    // }

    this.update_activenav(this.activeNav);
  }

  // subscribeToAllTables(data) {
  //   try {
  //     data["data"]["tables"].forEach((tableid) => {
  //       this.subscribe_to_mqtt_topic(
  //         localStorage.getItem("restaurant_id") + "_" + tableid
  //       );
  //     });
  //   } catch (error) {
  //   }
  // }

  get_notification() {
    const formData: any = new FormData();
    formData.append('token', this.token);

    // [PHP_TO_NEST_ROLLOUT] routed through ApiService so migration switch applies centrally
    this.apiService
      .getTableNotifications(formData)
      .subscribe((data: any) => {
        if (data.status == 1) {
          this.populate_notification(data);
          this.noNotification = false;
        } else this.noNotification = true;
      },
      (error) => {
        console.error("Error while fetching notifications count", error?.message);
      }
    );
  }

  update_activenav(type) {
    if (type === 'rn') {
      this.activeNav = 'rn';
      this.get_notification();
    } else if (type === 'ro') {
      this.activeNav = 'ro';
      // this.get_my_orders();
    }
  }

  async openModal(mid, oid, oids, data) {
    const { OrderDetailsComponent } = await import(
      /* webpackPrefetch: true */ '../server/components/order-details/order-details.component'
    );
    const dialogRef = this.dialog.open(OrderDetailsComponent, {
      data: {
        order_id: oid,
        order_ids: oids,
        mid,
      },
      maxWidth: this.modalWidth,
      maxHeight:'100vh'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      if (result.ack) {
        this.ack_notification(mid);
        this.commonService.sendMessage(
          this.translationText.TABLESERVICE_UPDATED
        );
      }
    });

    this._eventTracker.easyeat_track_event('PAYMENT_REQUEST_VIEWED', {
      TABLE_NO: data.table_no || 'N/A',
      REQUEST_TAB: 'TABLE SERVICE',
      FLOOR_NAME: data.floor_name || 'N/A',
      TIME_TAKEN_TO_SERVICE:
        Math.floor(Date.now() / 1000) - Number(data.time_stamp) || 0,
      SERVICE_REQUESTED: data.message || 'N/A',
    });
  }

  populate_notification(notifications) {
    this.allNotification = [];
    if (notifications['status'] === 1) {
      for (const notification of notifications['data']) {
        if (notification['ack'] === 0) {
          let cc = notification['data']['service_type'] == 'collect cash';
          this.allNotification.push({
            username: notification['sender_name'],
            floor_name: notification['data']['floor_name'],
            table_no: notification['data']['table_no'],
            message: notification['data']['msg_text'],
            message_id: notification['mid'],
            order_id: notification['data']['order_id'],
            order_ids: notification['data']['order_ids'],
            collect_cash: cc,
            time_stamp: parseInt(notification['time_stamp']),
            time_text: notification['time_text'],
            specifics: this.addSpecifics(notification),
          });
        }
      }

      this.allNotification.sort((a, b) => b.time_stamp - a.time_stamp);
    }
  }

  addSpecifics(notification) {
    if (notification['data']['service_type'] !== 'collect cash') {
      let x = [];
      try {
        notification.data[
          notification['data']['service_type']
        ].subcategories.forEach((item) => x.push(item));
      } catch {}
      return x;
    } else return '';
  }

  payment_status_in_str(paymentstatus: string) {
    if (paymentstatus === '1') {
      return 'Not paid';
    } else if (paymentstatus === '2') {
      return 'Partially paid';
    } else if (paymentstatus === '3') {
      return 'Paid';
    } else if (paymentstatus === '4') {
      return 'Paid';
    }
  }

  get_message_from_message_type(messagetype, server_msg) {
    if (messagetype === 'water') {
      return 'need water here';
    }
    if (messagetype === 'napkin') {
      return 'need napkin here';
    }
    if (messagetype === 'sauces') {
      return 'need sauce here';
    }
    if (messagetype === 'service') {
      return 'need service';
    }
    if (messagetype === 'cutlery') {
      return 'need cutlery here';
    }
    if (messagetype === 'bill') {
      return 'need bill';
    }
    return server_msg;
  }

  ack_notification(messageid) {
    const formData: any = new FormData();
    formData.append('token', this.token);
    formData.append('message_id', messageid);
    // [PHP_TO_NEST_ROLLOUT] routed through ApiService so migration switch applies centrally
    this.apiService
      .acknowelgeTableNotification(formData)
      .subscribe((data: any) => {
        this.update_activenav(this.activeNav);
        this.commonService.sendMessage('tableservice updated');
      });
  }
}
